<ng-container *ngIf="wod$ | async as timeslot">
  <ng-container *ngIf="useV1()">
    <app-data-v1 (participantSelected)="participantSelected.emit($event)"></app-data-v1>
  </ng-container>
  <ng-container *ngIf="useV2()">
    <app-data-v2></app-data-v2>
  </ng-container>
</ng-container>
